import { Common } from '../common';
import { MessageRequest } from '../models/previsit/messageRequest';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(urlIdentifier: string): Promise<MessageRequest> {
    const url = this.common.constructPath(`/patient-previsit/message-requests`);
    return this.common.postJSON(url, { urlIdentifier });
  }

  async findOneById(requestId: string): Promise<MessageRequest> {
    const url = this.common.constructPath(
      `/patient-previsit/message-requests/${requestId}`,
    );
    return this.common.getJSON(url);
  }

  async update(
    requestId: string,
    phoneNumber: string,
  ): Promise<{ success: boolean; reason?: string }> {
    const url = this.common.constructPath(
      `/patient-previsit/message-requests/${requestId}`,
    );
    return this.common.patchJSON(url, { phoneNumber });
  }
}
